export const match = <T>(
  cases: [T, boolean | (() => boolean)][],
): T | undefined => {
  for (const [value, condition] of cases) {
    const result = typeof condition === "function" ? condition() : condition;
    if (result) return value;
  }
  return undefined;
};
